// extracted by mini-css-extract-plugin
export var label = "_dy-1";
export var reminder = "_dy-0";